module.exports = __webpack_public_path__ + "media/images/icons/flags/MO-413f3d4498d9645eeb823961643b6ce9.svg";